import { defineRouter } from '#q-app/wrappers';
import {
  createMemoryHistory,
  createRouter,
  createWebHashHistory,
  createWebHistory,
} from 'vue-router';
import routes from './routes';
import { Loading } from 'quasar';

/*
 * If not building with SSR mode, you can
 * directly export the Router instantiation;
 *
 * The function below can be async too; either use
 * async/await or return a Promise which resolves
 * with the Router instance.
 */

export default defineRouter(function (/* { store, ssrContext } */) {
  const createHistory = process.env.SERVER
    ? createMemoryHistory
    : process.env.VUE_ROUTER_MODE === 'history'
      ? createWebHistory
      : createWebHashHistory;

  const Router = createRouter({
    scrollBehavior: () => ({ left: 0, top: 0 }),
    routes,

    // Leave this as is and make changes in quasar.conf.js instead!
    // quasar.conf.js -> build -> vueRouterMode
    // quasar.conf.js -> build -> publicPath
    history: createHistory(process.env.VUE_ROUTER_BASE),
  });

  // Hook: ANTES de Iniciar la Navegación (Muestra el Spinner)
  Router.beforeEach((to, from, next) => {
    // Solo mostramos si la ruta de destino es diferente.
    if (to.fullPath !== from.fullPath) {
      // Muestra el spinner de Quasar
      Loading.show({
        message: 'Cargando...',
      });
    }

    next(); // Continúa la navegación
  });

  // Hook: DESPUÉS de Completarse la Navegación (Oculta el Spinner)
  Router.afterEach(() => {
    // Oculta el spinner una vez que el componente de destino está cargado
    Loading.hide();
  });

  return Router;
});
